/*
 * @Author: your name
 * @Date: 2021-05-15 22:04:43
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-01-10 18:37:09
 * @FilePath: /卫星/weixing/src/main.js
 */
import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import router from './router'

Vue.use(ViewUI);

Vue.config.productionTip = false

new Vue({
 router,
 render: h => h(App)
}).$mount('#app')

